
import {
  ref,
  watch,
  nextTick,
  computed,
  onMounted,
  onBeforeUpdate,
  defineComponent,
} from 'vue';
import type {TopMenuItem} from './types';
// import useResize from '@/composables/useResize';
import useResize from '../../util/theme_composable/useResize';
import type {PropType, ComponentPublicInstance} from 'vue';
// import NavigationLink from '@/components/Topbar/NavigationLink.vue';
import NavigationLink from '../Topbar/NavigationLink.vue';
// import NavigationMore from '@/components/Topbar/NavigationMore.vue';
import NavigationMore from '../Topbar/NavigationMore.vue';


export default defineComponent({
  name: 'OxdNavigation',

  components: {
    'oxd-navigation-link': NavigationLink,
    'oxd-navigation-more': NavigationMore,
  },

  props: {
    menuItems: {
      type: Array as PropType<TopMenuItem[]>,
      required: false,
      default: () => [],
    },
  },
  
  setup(props, context) {
    const lastMenuItemWidth = ref(0);
    const navbar = ref<HTMLElement>();
    const visibleMenuItems = ref(props.menuItems);
    const hiddenMenuItems = ref<TopMenuItem[]>([]);
    const menuItemsRefs = ref<ComponentPublicInstance[]>([]);
    // const {width} = useResize(navbar);
    const width = ref(99999);

    const setMenuItem = ($el: ComponentPublicInstance | null) => {
      if ($el) menuItemsRefs.value.push($el);
      return undefined;
    };

    const menuClasses = computed(() => {
      return props.menuItems.map((item) => {
        return {
          'oxd-topbar-body-nav-tab': true,
          '--parent': item.children.length > 0,
          '--visited': item.active,
        };
      });
    });

    const getHTMLElementWidth = ($el: HTMLElement) => {
      const elStyles = window.getComputedStyle($el);
      return $el.clientWidth + parseInt(elStyles.marginRight);
    };

    const arrangeMenuItems = (menuItems: ComponentPublicInstance[]) => {
      // offset the width of "more" element
      let widthOffset = hiddenMenuItems.value.length > 0 ? 80 : 0;
      if (context.slots.default?.()) widthOffset += 35;
      const menuItemsWidth = menuItems.reduce((acc, menuItem) => {
        return acc + getHTMLElementWidth(menuItem.$el);
      }, widthOffset);

      // if total with of menu items is greater than nav bar
      // remove last menu, add it to hidden menu + store it's width
      if (menuItemsWidth > width.value) {
        lastMenuItemWidth.value = getHTMLElementWidth(
          menuItems[menuItems.length - 1].$el,
        );
        const lastMenuItem = visibleMenuItems.value.pop();
        if (lastMenuItem) hiddenMenuItems.value.unshift(lastMenuItem);
      }

      if (
        hiddenMenuItems.value.length > 0 &&
        width.value > menuItemsWidth + lastMenuItemWidth.value
      ) {
        nextTick().then(() => {
          const lastHiddenMenuItem = hiddenMenuItems.value.shift();
          if (lastHiddenMenuItem)
            visibleMenuItems.value.push(lastHiddenMenuItem);
        });
      }
    };

    // trigger menu side effects. ie: adding/removing items
    watch(menuItemsRefs, arrangeMenuItems);

    // arrange menu items once after dom loaded
    onMounted(async () => {
      await nextTick();
      arrangeMenuItems(menuItemsRefs.value);
    });

    onBeforeUpdate(() => {
      // reset menu refs array as vue re-render
      menuItemsRefs.value = [];
    });

    return {
      width,
      navbar,
      setMenuItem,
      menuClasses,
      menuItemsRefs,
      hiddenMenuItems,
      visibleMenuItems,
    };
  },
});
